import {
    Component,
    Input,
    SimpleChanges,
    OnChanges,
    inject,
} from '@angular/core';
import {
    DxDataGridComponent,
    DxFormComponent,
    DxTemplateDirective,
} from 'devextreme-angular';
import {
    DxiColumnComponent,
    DxiItemComponent,
    DxoColumnChooserComponent,
    DxoExportComponent,
    DxoFilterRowComponent,
    DxoHeaderFilterComponent,
    DxoLoadPanelComponent,
    DxoPagerComponent,
    DxoPagingComponent,
    DxoPositionComponent,
    DxoScrollingComponent,
    DxoSearchComponent,
    DxoSearchPanelComponent,
    DxoSelectionComponent,
    DxoSortingComponent,
    DxoToolbarComponent,
} from 'devextreme-angular/ui/nested';
import { FilterPanelComponent } from '../../../../../components/library/filter-panel/filter-panel.component';
import {
    FilterConfig,
    GridPageComponent,
} from '../../../../common/grid-page.component';
import {
    InvoiceHistoryGridViewDto,
    InvoiceStatus,
} from '@services';
import EnumUtils from '../../../../../shared/enum-utils';
import { CommonModule } from '@angular/common';
import { DATE_TIME_FORMAT } from 'src/app/shared/constants';
import { UserAvatarEmailComponent } from 'src/app/components/utils/user-avatar-email/user-avatar-email.component';
import { CustomStore } from 'devextreme-aspnet-data-nojquery';
import { InvoiceStatusPipe } from 'src/app/pipes/invoice-status.pipe';

@Component({
    selector: 'app-invoice-history',
    imports: [
        CommonModule,
        DxDataGridComponent,
        DxoScrollingComponent,
        DxoPagingComponent,
        DxoPagerComponent,
        DxoLoadPanelComponent,
        DxoSortingComponent,
        DxoHeaderFilterComponent,
        DxoFilterRowComponent,
        DxoColumnChooserComponent,
        DxoPositionComponent,
        DxoSearchComponent,
        DxoSearchPanelComponent,
        DxoSelectionComponent,
        DxoExportComponent,
        DxoToolbarComponent,
        DxiItemComponent,
        DxiColumnComponent,
        DxTemplateDirective,
        FilterPanelComponent,
        DxFormComponent,
        UserAvatarEmailComponent,
        InvoiceStatusPipe,
    ],
    providers: [InvoiceStatusPipe],
    templateUrl: './invoice-history.component.html',
})
export class InvoiceHistoryComponent
    extends GridPageComponent<InvoiceHistoryGridViewDto>
    implements OnChanges
{
    @Input() number: string | null = null;
    protected override exportName: string = 'Invoice PO Report';
    protected offset: number = 160;

    private invoiceStatusPipe = inject(InvoiceStatusPipe);

    dateTimeFormat = DATE_TIME_FORMAT;
    dataSource :  CustomStore | InvoiceHistoryGridViewDto[] = [];

    statusOptions = EnumUtils.getEnumOptions(InvoiceStatus, (v) =>
        this.invoiceStatusPipe.transform(v),
    );

    createdByFilter = this.userNameOrEmailFilter('createdBy');

    protected override filterConfig: FilterConfig[] = [
        {
            field: 'createdBy.name',
            op: 'contains',
            customFilter: this.createdByFilter,
        },
        { field: 'created', op: '>=' },
        { field: 'status', op: '=' },
    ];

    constructor() {
        super();
        this.init(InvoiceHistoryGridViewDto);
    }

    protected getBadgeClass(status: InvoiceStatus | undefined): string {
        return EnumUtils.getInvoiceStatusBadgeClass(status);
    }

    ngOnChanges(changes: SimpleChanges): void {
        if (changes['number']) {
            this.dataSource = this.dataSources.invoiceHistory(
                this.number,
            );
        }
    }
}
